var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ul',{staticClass:"l-side-partners"},_vm._l((_vm.filteredProjects),function(project){return _c('ListItemRoom',{key:project.id,attrs:{"partner":project.partner,"project":project}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }